// extracted by mini-css-extract-plugin
export default {"wrapper":"Default_wrapper__HhG9I"};